export const EdgelessPresentationConsts = {
    BlackBackground: 'blocksuite:presentation:blackBackground',
    FillScreen: 'blocksuite:presentation:fillScreen',
    HideToolbar: 'blocksuite:presentation:hideToolbar',
};
//# sourceMappingURL=consts.js.map